<template>
  <v-dialog :value="dialogProp.show" persistent max-width="700">
    <v-card class="elevation-12">
      <v-toolbar dense :dark="$vuetify.theme.dark" color="primary">
        <v-toolbar-title>
          {{ $t(dialogProp.readonly
            ? 'Просмотр позиции'
            : 'Редактирование позиции') }}
        </v-toolbar-title>
      </v-toolbar>
      <v-row v-if="!!generalError || isLoading" class="my-0 py-0 mx-1">
        <v-col cols="12">
          <v-progress-linear :active="isLoading" color="loader" indeterminate />
        </v-col>
        <v-col class="mx-1">
          <general-error v-if="!!generalError" />
        </v-col>
      </v-row>
      <v-card-text class="pt-3">
        <position-info-fix
            v-if="dialogProp.lot.lotType === LOT_TYPES.REQUEST_OFFERS && dialogProp.lot.premiumType === PREMIUM_TYPES.FIX"
            ref="position"
            :lot-description="lotDescription"
            :lot-owner-organization-name="lotOwnerOrganizationName"
            :position-info="position"
            :readonly="dialogProp.readonly"
            :validated="updatePosition" />
        <position-divisible-volume-info-fix
            v-if="dialogProp.lot.lotType === LOT_TYPES.REQUEST_OFFERS_DIVISIBLE_VOLUME && dialogProp.lot.premiumType === PREMIUM_TYPES.FIX"
            ref="position"
            :lot-description="lotDescription"
            :lot-owner-organization-name="lotOwnerOrganizationName"
            :position-info="position"
            :readonly="dialogProp.readonly"
            :validated="updatePosition" />
      </v-card-text>
      <v-card-actions>
        <v-spacer />
        <v-btn
            id="cancelConfirmBtn"
            class="ma-1"
            color="primary"
            @click="cancel">
          {{ $t(dialogProp.readonly
            ? 'Закрыть'
            : 'Отмена') }}
        </v-btn>
        <v-btn
            v-if="!dialogProp.readonly"
            id="continueOperationBtn"
            class="ma-1"
            color="primary"
            :disabled="isLoading"
            @click.stop="continueOperation">
          {{ $t('Продолжить') }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
  import PositionInfoFix from './PositionInfoFix.vue'
  import PositionDivisibleVolumeInfoFix from './PositionDivisibleVolumeInfoFix.vue'
  import GeneralError from '@/components/reused/common/GeneralError.vue'
  import { LOT_TYPES, PREMIUM_TYPES } from '@/constants/business'
  import { LOT_POSITIONS_MANAGEMENT } from '@/constants/store'
  import { mapActions, mapState } from 'vuex'

  export default {
    components: {
      GeneralError,
      PositionInfoFix,
      PositionDivisibleVolumeInfoFix
    },
    props: {
      dialogProp: {
        type: Object,
        default: () => {
          return {
            lot: {
              lotId: null,
              premiumType: null
            },
            positionId: null,
            readonly: false,
            show: false,
            callback: null
          }
        }
      }
    },
    data () {
      return {
        LOT_TYPES,
        PREMIUM_TYPES,
        isLoading: false
      }
    },
    computed: {
      ...mapState(LOT_POSITIONS_MANAGEMENT.NAMESPACE, {
        position: state => (state[LOT_POSITIONS_MANAGEMENT.STATE.CURRENT_POSITION] || {})
      }),
      lotDescription () {
        return this.dialogProp.lot?.lotDescription
      },
      lotOwnerOrganizationName () {
        return this.dialogProp.lot?.clientOrganizationFullName || this.dialogProp.lot?.organizer?.organizationName
      }
    },
    created () {
      this.clearStore().then(() => {
        if (!this.dialogProp.lot.premiumType ||
          !this.dialogProp.lot.lotId ||
          !this.dialogProp.positionId) {
          this.showErrorAction({
            message: this.$t('Данные для изменения позиции указаны некорректно.')
          })
          return
        }
        this.getPositionInfo()
      })
    },
    methods: {
      ...mapActions(LOT_POSITIONS_MANAGEMENT.NAMESPACE, {
        getPositionInfoAction: LOT_POSITIONS_MANAGEMENT.ACTIONS.GET_POSITION_INFO,
        updatePositionAction: LOT_POSITIONS_MANAGEMENT.ACTIONS.UPDATE_POSITION,
        clearPositionInfoAction: LOT_POSITIONS_MANAGEMENT.ACTIONS.CLEAR_POSITION_INFO
      }),
      clearStore: async function () {
        return Promise.all(
          [
            this.hideErrorAction(),
            this.clearPositionInfoAction()
          ])
      },
      continueOperation: async function () {
        try {
          this.isLoading = true
          await this.$refs.position.validate()
          if (this.dialogProp.callback) {
            await this.dialogProp.callback()
            this.isLoading = false
            this.cancel()
          }
        } catch (error) {
          this.isLoading = false
          this.throwIfUnknownError(error)
        }
      },
      getPositionInfo: async function () {
        try {
          this.isLoading = true
          await this.getPositionInfoAction({
            lotId: this.dialogProp.lot.lotId,
            lotType: this.dialogProp.lot.lotType,
            premiumType: this.dialogProp.lot.premiumType,
            positionId: this.dialogProp.positionId
          })
          this.isLoading = false
        } catch (error) {
          this.isLoading = false
          this.throwIfNotServerError(error)
        }
      },
      updatePosition: async function (position) {
        await this.updatePositionAction({
          lotId: this.dialogProp.lot.lotId,
          lotType: this.dialogProp.lot.lotType,
          premiumType: this.dialogProp.lot.premiumType,
          positionId: this.dialogProp.positionId,
          position
        })
      },
      cancel: function () {
        this.$emit('close')
      }
    }
  }
</script>
